module.exports = __webpack_public_path__ + "img/figure-11.833758ff.png";